import React from 'react';
import '../../../styles/venere-colors.css';
import VenereBanner from '../core/VenereBanner';

interface VenereSimpleLayoutProps {
  children: React.ReactNode;
  className?: string;
  showBackButton?: boolean;
  onBackClick?: () => void;
  backButtonText?: string;
  showUserAvatar?: boolean;
  onUserAvatarClick?: () => void;
  expertInfo?: {
    name: string;
    familyName: string;
    role: string;
    avatar?: string;
  };
}

export const VenereSimpleLayout: React.FC<VenereSimpleLayoutProps> = ({
  children,
  className = '',
  showBackButton = false,
  onBackClick,
  backButtonText = 'Back',
  showUserAvatar = false,
  onUserAvatarClick,
  expertInfo,
}) => {
  return (
    <div className="min-h-screen bg-white venere-content">
      {/* Simple Top Banner - Full width */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 shadow-sm">
        <VenereBanner
          showBackButton={showBackButton}
          onBackClick={onBackClick}
          backButtonText={backButtonText}
          showUserAvatar={showUserAvatar}
          onUserAvatarClick={onUserAvatarClick}
          expertInfo={expertInfo}
        />
      </div>

      {/* Main Content - Add top padding for fixed banner */}
      <main className={`${className} scrollbar-hide venere-content`} style={{ msOverflowStyle: 'none', scrollbarWidth: 'none' }}>
        <div className="pt-4 scrollbar-hide venere-content" style={{ msOverflowStyle: 'none', scrollbarWidth: 'none' }}>
          {children}
        </div>
      </main>
    </div>
  );
};

export default VenereSimpleLayout; 